import { SET_ROUTE_BLOCK, type AppState } from '@glass/web/modules/app';

const setRouteBlockAction = ({ onBlock }: AppState) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (!__BROWSER__ && __DEV__) {
    throw new Error('setRouteBlock can only be run in the browser');
  }
  return {
    type: SET_ROUTE_BLOCK,
    payload: {
      onBlock,
    },
  };
};

export default setRouteBlockAction;
